// axiosWrapper.ts
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

axios.interceptors.response.use(
    (response: AxiosResponse) => {
        if (response.headers["content-type"] !== "application/json") {
            throw new Error(response.statusText);
        }
        return response;
    }
)

const createAuthInstance = (token: string) => {
    return axios.create({
        headers: {
            "X-admin-token": token,
            "Content-Type": "application/json"
        },
    });
};

type Config = AxiosRequestConfig;

const auth = {
    get<T = any>(
        url: string,
        token: string,
        config?: Config
    ): Promise<AxiosResponse<T>> {
        return createAuthInstance(token).get<T>(url, config);
    },
    post<T = any>(
        url: string,
        data: any,
        token: string,
        config?: Config
    ): Promise<AxiosResponse<T>> {
        return createAuthInstance(token).post<T>(url, data, config);
    },
    put<T = any>(
        url: string,
        data: any,
        token: string,
        config?: Config
    ): Promise<AxiosResponse<T>> {
        return createAuthInstance(token).put<T>(url, data, config);
    },
    delete<T = any>(
        url: string,
        token: string,
        config?: Config
    ): Promise<AxiosResponse<T>> {
        return createAuthInstance(token).delete<T>(url, config);
    },
};

const fileUpload = <T = any>(
    file: File | Blob,
    token: string,
    fieldName = "file",
    config?: Config
): Promise<AxiosResponse<T>> => {
    const formData = new FormData();
    formData.append(fieldName, file);

    const url = import.meta.env.VITE_API_ENDPOINT + '/file'

    return createAuthInstance(token).post<T>(url, formData, {
        ...config,
        headers: {
            ...config?.headers,
            "X-admin-token": token,
            "Content-Type": "multipart/form-data",
        },
    });
};

function getToken() {
    return localStorage.getItem("admin-auth")
}

export {
    auth,
    fileUpload,
    getToken
};
